    document.addEventListener( 'DOMContentLoaded', function() {
        let helpersApi = null;
        let submenuOneApi = null;
        let menuTwoApi = null;
        let submenuTwoApi = null;
        function helpers() {
            if ( helpersApi ) {
                return helpersApi;
            }
            gsap.registerPlugin( CustomEase, SplitText );
            CustomEase.create( 'hop', '.75, 0, .25, 1' );
            const splitMap = new Map();
            const openSplits = [];
            function loadAnimation( time ) {
                requestAnimationFrame( loadAnimation );
            }
            requestAnimationFrame( loadAnimation );
            function registerMenu( container, selector, includeInOpen ) {
                if ( ! container ) {
                    return;
                }
                if ( splitMap.has( container ) ) {
                    return;
                }
                const textElements = container.querySelectorAll( selector );
                if ( ! textElements.length ) {
                    return;
                }
                const containerSplits = [];
                textElements.forEach( function( element ) {
                    const split = SplitText.create(
                        element,
                        {
                            type: 'lines',
                            mask: 'lines',
                            linesClass: 'line'
                        }
                    );
                    containerSplits.push( split );
                    gsap.set(
                        split.lines,
                        {
                            y: '-110%'
                        }
                    );
                } );
                splitMap.set( container, containerSplits );
                if ( includeInOpen ) {
                    openSplits.push( containerSplits );
                }
            }
            function splitMenu( container ) {
                const splits = splitMap.get( container ) || [];
                return splits.flatMap( function( split ) {
                    return split.lines;
                } );
            }
            helpersApi = {
                registerMenu: registerMenu,
                splitMenu: splitMenu,
                openSplits: openSplits
            };
            return helpersApi;
        }
        function submenuOneController() {
            if ( submenuOneApi ) {
                return submenuOneApi;
            }
            helpers();
            const header = document.querySelector( 'header' );
            const submenuOne = document.querySelector( '.submenu' );
            const explore = document.querySelector( '.explore' );
            if ( ! header || ! submenuOne ) {
                submenuOneApi = null;
                return null;
            }
            const submenuOneBody = submenuOne.querySelector( '.content' );
            const submenuOneCollections = submenuOne.querySelectorAll( '.collections .collection[data-collection]' );
            if ( ! submenuOneBody || ! submenuOneCollections.length ) {
                submenuOneApi = null;
                return null;
            }
            const submenuOneCollectionMap = new Map();
            submenuOneCollections.forEach( function( collection ) {
                const id = collection.getAttribute( 'data-collection' );
                if ( id ) {
                    submenuOneCollectionMap.set( id, collection );
                }
            } );
            const submenuOneContent = header.querySelector( '.content .sections .section.two' );
            const submenuOneOverlay = document.querySelector( 'section.overlay' );
            const menuOneLinks = submenuOneContent ? submenuOneContent.querySelectorAll( '.links ul li[data-collection]' ) : [];
            if ( ! submenuOneContent || ! menuOneLinks.length ) {
                submenuOneApi = null;
                return null;
            }
            const submenuOneLinks = submenuOne.querySelectorAll( '.content .collections .collection .sections .section.one .blocks .block .links > ul' );
            function submenuOnePosition() {
                const rect = header.getBoundingClientRect();
                const offset = rect.bottom - 1;
                submenuOne.style.top = offset + 'px';
                if ( explore ) {
                    explore.style.top = offset + 'px';
                    explore.style.height = 'calc(100dvh - ' + offset + 'px)';
                }
            }
            function findSubmenuOneCollection( id ) {
                if ( ! id ) {
                    return null;
                }
                if ( submenuOneCollectionMap.has( id ) ) {
                    return submenuOneCollectionMap.get( id );
                }
                let match = null;
                const lowerId = id.toLowerCase();
                submenuOneCollectionMap.forEach( function( collection, key ) {
                    if ( ! match && key.toLowerCase() === lowerId ) {
                        match = collection;
                    }
                } );
                return match;
            }
            function isInside( root, target ) {
                if ( ! root || ! target ) {
                    return false;
                }
                return root === target || root.contains( target );
            }
            submenuOnePosition();
            let ticking = false;
            window.addEventListener( 'resize', submenuOnePosition );
            window.addEventListener(
                'scroll',
                function() {
                    if ( ticking ) {
                        return;
                    }
                    ticking = true;
                    requestAnimationFrame(
                        function() {
                            submenuOnePosition();
                            ticking = false;
                        }
                    );
                },
                {
                    passive: true
                }
            );
            gsap.set(
                submenuOneBody,
                {
                    clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
                    yPercent: -50,
                    opacity: 1
                }
            );
            submenuOneCollections.forEach( function( collection ) {
                collection.style.display = 'none';
            } );
            let submenuOneOpen = false;
            let submenuOneCurrentCollection = null;
            const submenuOneAnimation = gsap.timeline(
                {
                    paused: true,
                    onStart: function() {
                        submenuOne.classList.add( 'active' );
                        if ( submenuOneOverlay ) {
                            submenuOneOverlay.classList.add( 'active' );
                        }
                    },
                    onReverseComplete: function() {
                        submenuOne.classList.remove( 'active' );
                        if ( submenuOneOverlay ) {
                            submenuOneOverlay.classList.remove( 'active' );
                        }
                        submenuOneCollections.forEach( function( collection ) {
                            collection.style.display = 'none';
                        } );
                        submenuOneCurrentCollection = null;
                        submenuOneOpen = false;
                        gsap.set(
                            submenuOneBody,
                            {
                                clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
                                yPercent: -50,
                                opacity: 1
                            }
                        );
                        gsap.set(
                            submenuOneLinks,
                            {
                                opacity: 1
                            }
                        );
                    }
                }
            );
            submenuOneAnimation.to(
                submenuOneBody,
                {
                    clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
                    duration: 0.375,
                    ease: 'power1.out'
                }
            );
            submenuOneAnimation.to(
                submenuOneBody,
                {
                    yPercent: 0,
                    opacity: 1,
                    duration: 0.375,
                    ease: 'power1.out'
                },
                '<'
            );
            submenuOneAnimation.fromTo(
                submenuOneLinks,
                {
                    opacity: 0.25
                },
                {
                    opacity: 1,
                    duration: 0.75,
                    ease: 'power1.out'
                },
                0
            );
            function showSubmenuOneCollection( collection ) {
                if ( submenuOneCurrentCollection === collection ) {
                    return;
                }
                submenuOneCollections.forEach( function( c ) {
                    if ( c === collection ) {
                        c.style.display = 'block';
                    } else {
                        c.style.display = 'none';
                    }
                } );
                submenuOneCurrentCollection = collection;
                const banner = collection.querySelector( '.sections .section.two .blocks .block .image' );
                if ( banner ) {
                    gsap.fromTo(
                        banner,
                        {
                            opacity: 0
                        },
                        {
                            opacity: 1,
                            duration: 0.75,
                            ease: 'power2.out'
                        }
                    );
                }
            }
            function openSubmenuOne( id ) {
                const collection = findSubmenuOneCollection( id );
                if ( ! collection ) {
                    return;
                }
                showSubmenuOneCollection( collection );
                if ( ! submenuOneOpen || submenuOneAnimation.reversed() ) {
                    submenuOneAnimation.play();
                    submenuOneOpen = true;
                }
            }
            function closeSubmenuOne() {
                if ( ! submenuOneOpen ) {
                    return;
                }
                submenuOneAnimation.reverse();
            }
            menuOneLinks.forEach( function( item ) {
                const id = item.getAttribute( 'data-collection' );
                if ( ! id ) {
                    return;
                }
                item.addEventListener(
                    'mouseenter',
                    function() {
                        openSubmenuOne( id );
                    }
                );
            } );
            submenuOneContent.addEventListener(
                'mouseleave',
                function( event ) {
                    const to = event.relatedTarget;
                    if ( isInside( submenuOneContent, to ) || isInside( submenuOne, to ) ) {
                        return;
                    }
                    closeSubmenuOne();
                }
            );
            submenuOne.addEventListener(
                'mouseleave',
                function( event ) {
                    const to = event.relatedTarget;
                    if ( isInside( submenuOneContent, to ) || isInside( submenuOne, to ) ) {
                        return;
                    }
                    closeSubmenuOne();
                }
            );
            submenuOneApi = {
                openSubmenuOne: openSubmenuOne,
                closeSubmenuOne: closeSubmenuOne
            };
            return submenuOneApi;
        }
        function menuTwoController() {
            if ( menuTwoApi ) {
                return menuTwoApi;
            }
            const helpersState = helpers();
            const registerMenu = helpersState.registerMenu;
            const splitMenu = helpersState.splitMenu;
            const openSplits = helpersState.openSplits;
            const menuTwo = document.querySelector( '[data-menu="2"]' );
            if ( ! menuTwo ) {
                menuTwoApi = null;
                return null;
            }
            const menuTwoPrimaryLinks = menuTwo.querySelector( '.menu .content .sections .section.one .blocks[data-blocks="2"] .block[data-block="1A"] .links > ul' );
            const menuTwoSecondaryLinks = menuTwo.querySelector( '.menu .content .sections .section.one .blocks[data-blocks="2"] .block[data-block="1B"] .links > ul' );
            const baseMenuTwoLines = [];
            const submenuTwoStates = [];
            if ( menuTwoPrimaryLinks ) {
                registerMenu(
                    menuTwoPrimaryLinks,
                    ':scope > li > .blocks .block .link',
                    true
                );
                const linesPrimary = splitMenu( menuTwoPrimaryLinks );
                baseMenuTwoLines.push.apply( baseMenuTwoLines, linesPrimary );
            }
            if ( menuTwoSecondaryLinks ) {
                registerMenu(
                    menuTwoSecondaryLinks,
                    ':scope > li > .blocks .block .link',
                    true
                );
                const linesSecondary = splitMenu( menuTwoSecondaryLinks );
                baseMenuTwoLines.push.apply( baseMenuTwoLines, linesSecondary );
            }
            const linksContainers = menuTwo.querySelectorAll( '.menu .content .sections .section.one .blocks .block .blocks .block .links ul li .blocks .block .blocks .block .links' );
            linksContainers.forEach( function( links ) {
                const firstLi = links.querySelector( ':scope > ul > li' );
                if ( ! firstLi ) {
                    return;
                }
                const label = firstLi.textContent ? firstLi.textContent.trim() : '';
                if ( label ) {
                    links.setAttribute( 'data-links', label );
                }
            } );
            const menuTwoIcon = document.querySelector( 'header .content .sections .section.three .blocks .block .icons .icon.one' );
            const submenuTwoIcon = document.querySelector( 'header .content .sections .section.one .blocks .block .icons .icon.one' );
            const menuTwoContent = menuTwo.querySelector( '.menu .content' );
            const menuTwoSections = menuTwo.querySelector( '.menu .content .sections' );
            let menuTwoBanner = menuTwo.querySelector( '.menu .content .sections .section.two .blocks .block .image' );
            const defaultBanner = menuTwoBanner ? menuTwoBanner.getAttribute( 'data-image' ) : '';
            const submenuTwoLinks = menuTwo.querySelectorAll( '.menu .content .sections .section.one .links > ul' );
            const announcements = document.querySelector( '.announcements' );
            const announcementsHeight = announcements ? announcements.offsetHeight : 0;
            const menuTwoTitle = document.querySelector( 'header .content .sections .section.one .blocks .block .blocks .block .text' );
            if ( ! menuTwoContent || ! menuTwoSections ) {
                menuTwoApi = null;
                return null;
            }
            let menuTwoTitleSplit = null;
            let defaultMenuTitle = '';
            if ( menuTwoTitle ) {
                defaultMenuTitle = menuTwoTitle.textContent.trim();
                menuTwoTitleSplit = SplitText.create(
                    menuTwoTitle,
                    {
                        type: 'lines',
                        mask: 'lines',
                        linesClass: 'line'
                    }
                );
                gsap.set(
                    menuTwoTitleSplit.lines,
                    {
                        y: '0%'
                    }
                );
            }
            let menuTwoAnimation = null;
            let openDelay = null;
            let isMenuTwoOpen = false;
            let isAnimating = false;
            function animateMenuTwoTitle( label ) {
                if ( ! menuTwoTitle ) {
                    return;
                }
                if ( menuTwoTitleSplit && menuTwoTitleSplit.lines && menuTwoTitleSplit.lines.length ) {
                    const oldSplit = menuTwoTitleSplit;
                    const oldLines = oldSplit.lines;
                    gsap.to(
                        oldLines,
                        {
                            y: '110%',
                            duration: 0.5,
                            ease: 'hop',
                            stagger: 0.025,
                            onComplete: function() {
                                oldSplit.revert();
                                menuTwoTitleSplit = null;
                                menuTwoTitle.textContent = label;
                                menuTwoTitleSplit = SplitText.create(
                                    menuTwoTitle,
                                    {
                                        type: 'lines',
                                        mask: 'lines',
                                        linesClass: 'line'
                                    }
                                );
                                gsap.fromTo(
                                    menuTwoTitleSplit.lines,
                                    {
                                        y: '-110%'
                                    },
                                    {
                                        y: '0%',
                                        duration: 0.5,
                                        ease: 'hop',
                                        stagger: 0.025
                                    }
                                );
                            }
                        }
                    );
                } else {
                    menuTwoTitle.textContent = label;
                    menuTwoTitleSplit = SplitText.create(
                        menuTwoTitle,
                        {
                            type: 'lines',
                            mask: 'lines',
                            linesClass: 'line'
                        }
                    );
                    gsap.fromTo(
                        menuTwoTitleSplit.lines,
                        {
                            y: '-110%'
                        },
                        {
                            y: '0%',
                            duration: 0.75,
                            ease: 'hop',
                            stagger: 0.025
                        }
                    );
                }
            }
            function changeMenuTwoBanner( url ) {
                if ( ! menuTwoBanner || ! url ) {
                    return;
                }
                const parent = menuTwoBanner.parentNode;
                const newBanner = menuTwoBanner.cloneNode( false );
                newBanner.style.backgroundImage = 'url( ' + url + ' )';
                newBanner.style.opacity = 0;
                parent.appendChild( newBanner );
                gsap.to(
                    newBanner,
                    {
                        opacity: 1,
                        duration: 1,
                        delay: 0.5,
                        ease: 'power2.out'
                    }
                );
                gsap.to(
                    menuTwoBanner,
                    {
                        opacity: 0,
                        duration: 1,
                        delay: 0.5,
                        ease: 'power2.out',
                        onComplete: function() {
                            parent.removeChild( menuTwoBanner );
                            menuTwoBanner = newBanner;
                        }
                    }
                );
            }
            const menuTwoImageItems = menuTwo.querySelectorAll( '.menu .content .sections .section.one li[data-image]' );
            menuTwoImageItems.forEach( function( item ) {
                item.addEventListener(
                    'click',
                    function() {
                        const url = item.getAttribute( 'data-image' ) || defaultBanner;
                        changeMenuTwoBanner( url );
                    }
                );
            });
            function updateSubmenuTwoIcon() {
                if ( ! submenuTwoIcon ) {
                    return;
                }
                let hasOpen = false;
                submenuTwoStates.forEach( function( submenuTwoState ) {
                    if ( submenuTwoState.isOpen ) {
                        hasOpen = true;
                    }
                } );
                if ( hasOpen ) {
                    submenuTwoIcon.classList.add( 'active' );
                } else {
                    submenuTwoIcon.classList.remove( 'active' );
                }
            }
            function splitSubmenuTwo( submenuTwoState ) {
                if ( submenuTwoState.splitsubmenuTwoSublinks && submenuTwoState.splitsubmenuTwoSublinks.length ) {
                    return;
                }
                const previousDisplay = submenuTwoState.submenuTwoContent.style.display;
                submenuTwoState.submenuTwoContent.style.display = 'block';
                registerMenu(
                    submenuTwoState.submenuTwoContent,
                    '.title h4, ul > li',
                    false
                );
                submenuTwoState.submenuTwoContent.style.display = previousDisplay || 'none';
                submenuTwoState.splitsubmenuTwoSublinks = splitMenu( submenuTwoState.submenuTwoContent );
                if ( submenuTwoState.splitsubmenuTwoSublinks.length ) {
                    gsap.set(
                        submenuTwoState.splitsubmenuTwoSublinks,
                        {
                            y: '-110%'
                        }
                    );
                }
            }
            function closeSubmenuTwoStates() {
                submenuTwoStates.forEach( function( submenuTwoState ) {
                    submenuTwoState.isOpen = false;
                    submenuTwoState.isAnimating = false;
                    if ( submenuTwoState.splitsubmenuTwoSublinks && submenuTwoState.splitsubmenuTwoSublinks.length ) {
                        gsap.set(
                            submenuTwoState.splitsubmenuTwoSublinks,
                            {
                                y: '-110%'
                            }
                        );
                    }
                    gsap.set(
                        submenuTwoState.submenuTwoContent,
                        {
                            y: 0
                        }
                    );
                    submenuTwoState.submenuTwoContent.style.display = 'none';
                } );
                updateSubmenuTwoIcon();
            }
            function toggleSubmenuTwo( submenuTwoState ) {
                splitSubmenuTwo( submenuTwoState );
                if ( ! submenuTwoState.splitsubmenuTwoSublinks.length ) {
                    return;
                }
                submenuTwoState.isAnimating = true;
                const menuOutDuration = 0.5;
                const menuInDuration = 0.75;
                const overlap = 0.4;
                if ( ! submenuTwoState.isOpen ) {
                    const previousDisplay = submenuTwoState.submenuTwoContent.style.display;
                    submenuTwoState.submenuTwoContent.style.display = 'block';
                    gsap.set(
                        submenuTwoState.submenuTwoContent,
                        {
                            y: 0
                        }
                    );
                    const rect = submenuTwoState.submenuTwoContent.getBoundingClientRect();
                    const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
                    const targetOffset = viewportHeight >= 900 ? 80 : 75;
                    const offset = targetOffset - rect.top;
                    gsap.set(
                        submenuTwoState.submenuTwoContent,
                        {
                            y: offset
                        }
                    );
                    submenuTwoState.submenuTwoContent.style.display = previousDisplay || 'none';
                    const timeline = gsap.timeline();
                    const labelText = submenuTwoState.submenuTwoLink.textContent.trim();
                    animateMenuTwoTitle( labelText );
                    const bannerImage = submenuTwoState.item.getAttribute( 'data-image' ) || defaultBanner;
                    changeMenuTwoBanner( bannerImage );
                    gsap.set(
                        submenuTwoState.splitMenuLines,
                        {
                            y: '0%'
                        }
                    );
                    gsap.set(
                        submenuTwoState.splitsubmenuTwoSublinks,
                        {
                            y: '-110%'
                        }
                    );
                    submenuTwoStates.forEach( function( other ) {
                        if ( other !== submenuTwoState && other.isOpen ) {
                            if ( other.splitsubmenuTwoSublinks && other.splitsubmenuTwoSublinks.length ) {
                                gsap.set(
                                    other.splitsubmenuTwoSublinks,
                                    {
                                        y: '-110%'
                                    }
                                );
                            }
                            other.submenuTwoContent.style.display = 'none';
                            other.isOpen = false;
                            other.isAnimating = false;
                        }
                    } );
                    timeline.to(
                        submenuTwoState.splitMenuLines,
                        {
                            y: '110%',
                            duration: menuOutDuration,
                            ease: 'hop',
                            stagger: 0.025
                        }
                    );
                    timeline.add(
                        function() {
                            submenuTwoState.submenuTwoContent.style.display = 'block';
                            submenuTwoState.submenuTwoContent.scrollTop = 0;
                        }
                    );
                    timeline.fromTo(
                        submenuTwoState.splitsubmenuTwoSublinks,
                        {
                            y: '-110%'
                        },
                        {
                            y: '0%',
                            duration: menuInDuration,
                            ease: 'hop',
                            stagger: 0.025
                        },
                        '-=' + overlap
                    );
                    timeline.call(
                        function() {
                            submenuTwoState.isAnimating = false;
                        }
                    );
                    submenuTwoState.isOpen = true;
                    updateSubmenuTwoIcon();
                } else {
                    const timeline = gsap.timeline();
                    animateMenuTwoTitle( defaultMenuTitle );
                    changeMenuTwoBanner( defaultBanner );
                    gsap.set(
                        submenuTwoState.splitsubmenuTwoSublinks,
                        {
                            y: '0%'
                        }
                    );
                    gsap.set(
                        submenuTwoState.splitMenuLines,
                        {
                            y: '-110%'
                        }
                    );
                    timeline.to(
                        submenuTwoState.splitsubmenuTwoSublinks,
                        {
                            y: '110%',
                            duration: menuOutDuration,
                            ease: 'hop',
                            stagger: 0.025,
                            onComplete: function() {
                                submenuTwoState.submenuTwoContent.style.display = 'none';
                                submenuTwoState.submenuTwoContent.scrollTop = 0;
                                gsap.set(
                                    submenuTwoState.submenuTwoContent,
                                    {
                                        y: 0
                                    }
                                );
                            }
                        }
                    );
                    timeline.to(
                        submenuTwoState.splitMenuLines,
                        {
                            y: '0%',
                            duration: menuInDuration,
                            ease: 'hop',
                            stagger: 0.025
                        },
                        '-=' + overlap
                    );
                    timeline.call(
                        function() {
                            submenuTwoState.isAnimating = false;
                        }
                    );
                    submenuTwoState.isOpen = false;
                    updateSubmenuTwoIcon();
                }
            }
            function closeSubmenuTwo() {
                if ( ! isMenuTwoOpen ) {
                    return;
                }
                let openSubmenuTwoState = null;
                submenuTwoStates.forEach( function( submenuTwoState ) {
                    if ( submenuTwoState.isOpen && ! openSubmenuTwoState ) {
                        openSubmenuTwoState = submenuTwoState;
                    }
                } );
                if ( openSubmenuTwoState ) {
                    if ( openSubmenuTwoState.isAnimating ) {
                        return;
                    }
                    toggleSubmenuTwo( openSubmenuTwoState );
                } else {
                    closeMenuTwo();
                }
            }
            function startMenuTwoOpen() {
                if ( ! menuTwoContent || ! menuTwoSections ) {
                    return;
                }
                if ( menuTwoAnimation ) {
                    menuTwoAnimation.kill();
                }
                menuTwoContent.style.display = 'block';
                menuTwoContent.style.pointerEvents = 'auto';
                const scrollContainers = menuTwo.querySelectorAll( '.menu .content .sections .section.one .blocks[data-blocks="2"]' );
                scrollContainers.forEach( function( sc ) {
                    sc.scrollTop = 0;
                } );
                if ( menuTwoBanner && defaultBanner ) {
                    menuTwoBanner.style.backgroundImage = 'url( ' + defaultBanner + ' )';
                }
                const timeline = gsap.timeline();
                menuTwoAnimation = timeline;
                timeline.to(
                    menuTwoContent,
                    {
                        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
                        duration: 1,
                        ease: 'hop'
                    }
                );
                timeline.to(
                    menuTwoSections,
                    {
                        yPercent: 0,
                        duration: 1,
                        ease: 'hop'
                    },
                    '<'
                );
                if ( menuTwoBanner ) {
                    timeline.to(
                        menuTwoBanner,
                        {
                            opacity: 1,
                            duration: 0.75,
                            ease: 'power2.out',
                            delay: 0.5
                        },
                        '<'
                    );
                }
                const allLines = [];
                openSplits.forEach( function( containerSplits ) {
                    containerSplits.forEach( function( split ) {
                        allLines.push.apply( allLines, split.lines );
                    } );
                } );
                if ( allLines.length ) {
                    timeline.to(
                        allLines,
                        {
                            y: '0%',
                            duration: 2,
                            ease: 'hop',
                            stagger: 0.0375
                        },
                        -0.15
                    );
                }
                if ( menuTwoIcon ) {
                    menuTwoIcon.classList.add( 'active' );
                }
                timeline.call(
                    function() {
                        isAnimating = false;
                    }
                );
            }
            function openMenuTwo() {
                isAnimating = true;
                document.body.setAttribute( 'data-two', '1' );
                setTimeout(
                    function() {
                        document.body.setAttribute( 'data-two', '2' );
                    },
                    1750
                );
                if ( openDelay ) {
                    openDelay.kill();
                    openDelay = null;
                }
                if ( menuTwoAnimation ) {
                    menuTwoAnimation.kill();
                    menuTwoAnimation = null;
                }
                const atTop = window.scrollY < 50;
                if ( announcements && announcementsHeight && atTop ) {
                    announcements.style.overflow = 'hidden';
                    gsap.set(
                        announcements,
                        {
                            height: announcementsHeight
                        }
                    );
                    gsap.to(
                        announcements,
                        {
                            height: 0,
                            duration: 0.375,
                            ease: 'hop'
                        }
                    );
                    openDelay = gsap.delayedCall(
                        0.2,
                        startMenuTwoOpen
                    );
                } else {
                    startMenuTwoOpen();
                }
                isMenuTwoOpen = true;
            }
            function closeMenuTwo() {
                if ( ! menuTwoContent || ! menuTwoSections ) {
                    return;
                }
                isAnimating = true;
                document.body.setAttribute( 'data-two', '3' );
                setTimeout(
                    function() {
                        document.body.setAttribute( 'data-two', '4' );
                    },
                    750
                );
                setTimeout(
                    function() {
                        document.body.setAttribute( 'data-two', '0' );
                    },
                    750
                );
                if ( openDelay ) {
                    openDelay.kill();
                    openDelay = null;
                }
                if ( menuTwoAnimation ) {
                    menuTwoAnimation.kill();
                    menuTwoAnimation = null;
                }
                if ( menuTwoIcon ) {
                    menuTwoIcon.classList.remove( 'active' );
                }
                const atTop = window.scrollY < 50;
                const timeline = gsap.timeline();
                menuTwoAnimation = timeline;
                timeline.to(
                    menuTwoContent,
                    {
                        clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
                        duration: 0.75,
                        ease: 'hop'
                    }
                );
                timeline.to(
                    menuTwoSections,
                    {
                        yPercent: -50,
                        duration: 0.75,
                        ease: 'hop'
                    },
                    '<'
                );
                timeline.to(
                    submenuTwoLinks,
                    {
                        opacity: 0,
                        duration: 0.5,
                        ease: 'power2.out'
                    },
                    '<'
                );
                if ( menuTwoBanner ) {
                    timeline.to(
                        menuTwoBanner,
                        {
                            opacity: 0,
                            duration: 0.5,
                            ease: 'power2.out'
                        },
                        '<'
                    );
                }
                if ( announcements && announcementsHeight && atTop ) {
                    timeline.to(
                        announcements,
                        {
                            height: announcementsHeight,
                            duration: 0.45,
                            ease: 'hop'
                        }
                    );
                }
                timeline.call(
                    function() {
                        openSplits.forEach( function( containerSplits ) {
                            const lines = containerSplits.flatMap( function( split ) {
                                return split.lines;
                            } );
                            gsap.set(
                                lines,
                                {
                                    y: '-110%'
                                }
                            );
                        } );
                    }
                );
                timeline.call(
                    function() {
                        gsap.set(
                            submenuTwoLinks,
                            {
                                opacity: 1
                            }
                        );
                        if ( announcements ) {
                            announcements.style.overflow = '';
                            announcements.style.height = '';
                        }
                        menuTwoContent.style.pointerEvents = 'none';
                        menuTwoContent.style.display = 'none';
                        if ( menuTwoBanner && defaultBanner ) {
                            menuTwoBanner.style.backgroundImage = 'url( ' + defaultBanner + ' )';
                        }
                        closeSubmenuTwoStates();
                        isAnimating = false;
                    }
                );
                isMenuTwoOpen = false;
            }
            menuTwoApi = {
                menuTwo: menuTwo,
                menuTwoPrimaryLinks: menuTwoPrimaryLinks,
                baseMenuTwoLines: baseMenuTwoLines,
                submenuTwoStates: submenuTwoStates,
                menuTwoIcon: menuTwoIcon,
                submenuTwoIcon: submenuTwoIcon,
                openMenuTwo: openMenuTwo,
                closeMenuTwo: closeMenuTwo,
                closeSubmenuTwo: closeSubmenuTwo,
                toggleSubmenuTwo: toggleSubmenuTwo
            };
            return menuTwoApi;
        }
        function submenuTwoController() {
            if ( submenuTwoApi ) {
                return submenuTwoApi;
            }
            const menuState = menuTwoController();
            if ( ! menuState || ! menuState.menuTwoPrimaryLinks ) {
                submenuTwoApi = null;
                return null;
            }
            const menuTwoPrimaryLinks = menuState.menuTwoPrimaryLinks;
            const baseMenuTwoLines = menuState.baseMenuTwoLines;
            const submenuTwoStates = menuState.submenuTwoStates;
            const toggleSubmenuTwo = menuState.toggleSubmenuTwo;
            const menuTwoIcon = menuState.menuTwoIcon;
            const openMenuTwo = menuState.openMenuTwo;
            const submenuTwoItems = menuTwoPrimaryLinks.querySelectorAll( ':scope > li[data-action="1"]' );
            submenuTwoItems.forEach( function( item ) {
                const submenuTwoLink = item.querySelector( ':scope .blocks .block .link' );
                const submenuTwoContent = item.querySelector( ':scope > .blocks .blocks[data-blocks="4"]' );
                const submenuTwoSublinks = submenuTwoContent ? submenuTwoContent.querySelector( 'ul' ) : null;
                if ( ! submenuTwoLink || ! submenuTwoContent || ! submenuTwoSublinks ) {
                    return;
                }
                submenuTwoContent.style.display = 'none';
                const submenuTwoState = {
                    item: item,
                    submenuTwoLink: submenuTwoLink,
                    submenuTwoContent: submenuTwoContent,
                    submenuTwoSublinks: submenuTwoSublinks,
                    splitMenuLines: baseMenuTwoLines,
                    splitsubmenuTwoSublinks: [],
                    isOpen: false,
                    isAnimating: false
                };
                submenuTwoLink.addEventListener(
                    'click',
                    function( event ) {
                        event.preventDefault();
                        const isOpen = menuTwoIcon && menuTwoIcon.classList.contains( 'active' );
                        if ( ! isOpen ) {
                            openMenuTwo();
                        }
                        if ( submenuTwoState.isAnimating ) {
                            return;
                        }
                        toggleSubmenuTwo( submenuTwoState );
                    }
                );
                submenuTwoStates.push( submenuTwoState );
            } );
            submenuTwoApi = {
                submenuTwoStates: submenuTwoStates
            };
            return submenuTwoApi;
        }
        function registerSubmenuOne() {
            submenuOneController();
        }
        function registerMenuTwo() {
            const menuState = menuTwoController();
            if ( ! menuState ) {
                return;
            }
            const menuTwoIcon = menuState.menuTwoIcon;
            const openMenuTwo = menuState.openMenuTwo;
            const closeMenuTwo = menuState.closeMenuTwo;
            const closeSubmenuTwo = menuState.closeSubmenuTwo;
            const submenuTwoIcon = menuState.submenuTwoIcon;
            if ( menuTwoIcon ) {
                menuTwoIcon.addEventListener(
                    'click',
                    function() {
                        const isOpen = menuTwoIcon.classList.contains( 'active' );
                        if ( ! isOpen ) {
                            openMenuTwo();
                        } else {
                            closeMenuTwo();
                        }
                    }
                );
            }
            const menuButton = document.querySelector( 'header .content .sections .section.one .blocks .block .blocks .block .button.circle' );
            if ( menuButton ) {
                menuButton.addEventListener(
                    'click',
                    function() {
                        closeSubmenuTwo();
                    }
                );
            }
            if ( submenuTwoIcon ) {
                submenuTwoIcon.addEventListener(
                    'click',
                    function() {
                        closeSubmenuTwo();
                    }
                );
            }
        }
        function registerSubmenuTwo() {
            submenuTwoController();
        }
        registerSubmenuOne();
        registerMenuTwo();
        registerSubmenuTwo();
    });
